<template>
  <read-text v-if="isPureText" :value="pureText"></read-text>
  <div class="sy-percentage" v-else>
    <el-input
      v-bind="{...$props}"
      :value="inputValue"
      type="text"
      @input="handleInput"
    >
      <em class="symbol" slot="suffix">%</em>
    </el-input>
  </div>
</template>
<script>
import _ from 'lodash-es'
import TransformMixin from 'fe-coms-share/paas/business/field-precision/percentage-mixin'
import {percentageProps, initValue} from './index'

export default {
  name: 'percentage',
  props: percentageProps,
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      updateFlag: false,
      inputValue: ''
    }
  },
  mixins: [TransformMixin],
  computed: {
    // 纯文本补齐'%'
    pureText () {
      const {inputValue, isPureText} = this
      return isPureText ? initValue(inputValue) : inputValue
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        if (this.updateFlag) {
          this.updateFlag = false
          return
        }
        this.updateValue(val)
      }
    }
  },
  mounted () {
    // 回显formData value的值
    this.updateValue(this.value)
  },
  methods: {
    // 输入框值修改去除非法字符和转化百分位
    handleInput (value) {
      const P_REG = /[\u4e00-\u9fa5a-z_A-Z!@#\$%\\\^&\*\)\(\+=\{\}\[\]\/",'<>~\`\?:;|]+$/g
      const REGEXP = /[^\-\d^\\.]+/g
      let payAmount = value.replace(P_REG, '').replace(/\s*/g, '').replace(REGEXP, '').replace('/\s/g', '').replace(/-/g, (_, index) => index === 0 ? '-' : '')
      this.inputValue = payAmount
      _.debounce(() => {
        this.emitChange(this.correctStrNum(this.transform(payAmount, 'divide')))
      }, 100)()
    },
    updateValue (value) {
      if (this.percentileValue) {
        this.inputValue = value
        this.emitChange(this.correctStrNum(this.transform(value, 'divide')))
      } else {
        this.inputValue = this.correctStrNum(this.transform(value))
        this.emitChange(value)
      }
    },
    emitChange (value) {
      if (_.eq(this.value, value)) {
        return
      }
      this.updateFlag = true
      this.$emit('change', value)
    }
  }
}
</script>
<style scoped lang="scss">
.sy-percentage {
  box-sizing: border-box;
  font-size: 0;
}

.sy-percentage .symbol {
  line-height: 32px;
  position: relative;
  left: -5px;
}
</style>
